import { Component } from '@angular/core';

@Component({
  selector: 'help',
  templateUrl: './help.component.html',
})
export class HelpComponent {}
